export default __webpack_public_path__ + "static/media/press-hero-mobile.db89d99a.png";